import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Promote an Application using CD with GitOps and ArgoCD`}</p>
    </PageDescription>
    <div {...{
      "className": "gatsby-resp-iframe-wrapper",
      "style": {
        "paddingBottom": "56.25%",
        "position": "relative",
        "height": "0",
        "overflow": "hidden"
      }
    }}>{` `}<iframe parentName="div" {...{
        "src": "https://www.youtube.com/embed/Fr85xbcM_es",
        "frameBorder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        "allowFullScreen": true,
        "style": {
          "position": "absolute",
          "top": "0",
          "left": "0",
          "width": "100%",
          "height": "100%"
        }
      }}></iframe>{` `}</div>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Prerequisites`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Complete lab `}<a parentName="li" {...{
              "href": "./ci"
            }}>{`Deploy an Application using CI Pipelines with Tekton`}</a>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_USERNAME`}</inlineCode>{` environment variable.
If you are participation in a workshop replace `}<inlineCode parentName="p">{`userdemo`}</inlineCode>{` with your assigned username (ex. `}<inlineCode parentName="p">{`user01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_USERNAME=userdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_PROJECT`}</inlineCode>{` environment variable.
If you are participation in a workshop replace `}<inlineCode parentName="p">{`projectdemo`}</inlineCode>{` based on your assigned username (ex. `}<inlineCode parentName="p">{`project01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_PROJECT=projectdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify Application is deployed in `}<strong parentName="p">{`QA`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">{`Select ArgoCD from the Console Link and login using OpenShift login`}</li>
          <li parentName="ul">{`Filter Applications by name `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode>{` (ie project01-qa)`}</li>
          <li parentName="ul">{`Select the application `}<inlineCode parentName="li">{`master-qa-\${TOOLKIT_PROJECT}-app`}</inlineCode>{` (ie master-qa-project01-app)
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "36.45833333333333%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAdmhAL//xAAWEAADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQEAAQUCVP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAABD/2gAIAQEABj8Cf//EABgQAAMBAQAAAAAAAAAAAAAAAAABIRGB/9oACAEBAAE/IeClRs//2gAMAwEAAgADAAAAEIPv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBAAAgICAwAAAAAAAAAAAAAAASEAETFhcZHR/9oACAEBAAE/EEhShs+wQFTGGZxdT//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Argo CD App",
                "title": "Argo CD App",
                "src": "/dev-guide/static/b772b725f9cab1d447b6f696a3473913/2e753/argo-app.jpg",
                "srcSet": ["/dev-guide/static/b772b725f9cab1d447b6f696a3473913/69549/argo-app.jpg 288w", "/dev-guide/static/b772b725f9cab1d447b6f696a3473913/473e3/argo-app.jpg 576w", "/dev-guide/static/b772b725f9cab1d447b6f696a3473913/2e753/argo-app.jpg 1152w", "/dev-guide/static/b772b725f9cab1d447b6f696a3473913/802dc/argo-app.jpg 1251w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify Application is running in the QA namespace corresponding to your username `}<inlineCode parentName="p">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode></p>
        <ul parentName="li">
          <li parentName="ul">{`Select `}<strong parentName="li">{`Developer`}</strong>{` perspective, select project `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode>{` and then select `}<strong parentName="li">{`Topology`}</strong>{` from the Console and see the application running
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1088px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "52.43055555555556%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIGA//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAHKgn6EQQV//8QAGhAAAgIDAAAAAAAAAAAAAAAAAAQBEBIhNP/aAAgBAQABBQJLbBlAj0V//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BR//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABUQAQEAAAAAAAAAAAAAAAAAABCB/9oACAEBAAY/Aox//8QAGhAAAgMBAQAAAAAAAAAAAAAAAREQITEAsf/aAAgBAQABPyEmBDcAzTqs71z/AP/aAAwDAQACAAMAAAAQw8//xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8QtEh//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAICAwEAAAAAAAAAAAAAAQAxESEQUXHw/9oACAEBAAE/ECQxevXcAKA8mALZlTcs+64bZ//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Deploy QA",
                "title": "Deploy QA",
                "src": "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/c3319/deploy-qa.jpg",
                "srcSet": ["/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/69549/deploy-qa.jpg 288w", "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/473e3/deploy-qa.jpg 576w", "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/c3319/deploy-qa.jpg 1088w"],
                "sizes": "(max-width: 1088px) 100vw, 1088px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Setup environment variable `}<inlineCode parentName="p">{`GIT_OPS_URL`}</inlineCode>{` for the git url using the value from previous step or as following`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`GIT_OPS_URL=http://\${TOOLKIT_USERNAME}:password@$(oc get route -n tools gogs --template='{{.spec.host}}')/toolkit/gitops
echo GIT_OPS_URL=\${GIT_OPS_URL}

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Clone the git repository and change directory`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`cd $HOME
git clone $GIT_OPS_URL
cd gitops

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the `}<inlineCode parentName="p">{`qa`}</inlineCode>{` and `}<inlineCode parentName="p">{`staging`}</inlineCode>{` directory in the git repository`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`ls -l qa/
ls -l staging/

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Promote the application from `}<strong parentName="p">{`QA`}</strong>{` to `}<strong parentName="p">{`STAGING`}</strong>{` by copying the app manifest files using git`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git config --local user.email "\${TOOLKIT_USERNAME}@example.com"
git config --local user.name "\${TOOLKIT_USERNAME}"

cp -a qa/\${TOOLKIT_PROJECT}/ staging/\${TOOLKIT_PROJECT}/

git add .
git commit -m "Promote Application from QA to STAGING environment for $TOOLKIT_PROJECT"
git push -u origin master

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify Application is deployed in `}<strong parentName="p">{`STAGING`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">{`Select ArgoCD from the Console Link and login using OpenShift login`}</li>
          <li parentName="ul">{`Filter Applications by namespace `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-staging`}</inlineCode>{` (ie project01-staging)`}</li>
          <li parentName="ul">{`It might take a couple minutes for the application to show up`}</li>
          <li parentName="ul">{`Select the application `}<inlineCode parentName="li">{`master-staging-\${TOOLKIT_PROJECT}-app`}</inlineCode>{` (ie master-staging-project01-app)`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`Refresh`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "36.45833333333333%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdmhAP/EABYQAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAQABBQJU/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAEP/aAAgBAQAGPwJ//8QAGBAAAgMAAAAAAAAAAAAAAAAAACEBEYH/2gAIAQEAAT8hwhMuf//aAAwDAQACAAMAAAAQi+//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAQQDAAAAAAAAAAAAAAABABEhMdFhcZH/2gAIAQEAAT8QtYoA5dwgpyYu7nV5P//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Argo CD App staging",
                "title": "Argo CD App staging",
                "src": "/dev-guide/static/76a89df78ba636dea68b96d723b41b75/2e753/argo-app-staging.jpg",
                "srcSet": ["/dev-guide/static/76a89df78ba636dea68b96d723b41b75/69549/argo-app-staging.jpg 288w", "/dev-guide/static/76a89df78ba636dea68b96d723b41b75/473e3/argo-app-staging.jpg 576w", "/dev-guide/static/76a89df78ba636dea68b96d723b41b75/2e753/argo-app-staging.jpg 1152w", "/dev-guide/static/76a89df78ba636dea68b96d723b41b75/802dc/argo-app-staging.jpg 1251w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify Application is running in the `}<strong parentName="p">{`STAGING`}</strong>{` namespace corresponding to your username `}<inlineCode parentName="p">{`\${TOOLKIT_PROJECT}`}</inlineCode></p>
        <ul parentName="li">
          <li parentName="ul">{`Select `}<strong parentName="li">{`Developer`}</strong>{` perspective, select project `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-staging`}</inlineCode>{` and then select `}<strong parentName="li">{`Topology`}</strong>{` from the Console and see the application running
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "51.041666666666664%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIFAQb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFLsHoDBQ//xAAdEAAABQUAAAAAAAAAAAAAAAAAAQIDBBARITE0/9oACAEBAAEFAoWX7FSD0BOv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBAAAgMAAAAAAAAAAAAAAAAAARAhQXH/2gAIAQEABj8CMUzj/8QAGxAAAgIDAQAAAAAAAAAAAAAAAREAMRBBkaH/2gAIAQEAAT8hQMheI0OQI0uT08n/2gAMAwEAAgADAAAAEGDP/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAEDAQE/ELWv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHRAAAQQCAwAAAAAAAAAAAAAAAQARMVEQIUFx8P/aAAgBAQABPxB2AIDvkWhAG1AmTgY6LyrCMYf/2Q==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Deploy Staging",
                "title": "Deploy Staging",
                "src": "/dev-guide/static/f15d649ec0a42a9ad4c79155fa4b96c8/2e753/deploy-staging.jpg",
                "srcSet": ["/dev-guide/static/f15d649ec0a42a9ad4c79155fa4b96c8/69549/deploy-staging.jpg 288w", "/dev-guide/static/f15d649ec0a42a9ad4c79155fa4b96c8/473e3/deploy-staging.jpg 576w", "/dev-guide/static/f15d649ec0a42a9ad4c79155fa4b96c8/2e753/deploy-staging.jpg 1152w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Propose a change for the Application in `}<strong parentName="p">{`STAGING`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">{`Update the replica count and create a new git branch in remote repo`}</li>
        </ul>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`cat > staging/\${TOOLKIT_PROJECT}/app/values.yaml <<EOF
global: {}
app:
  replicaCount: 2
EOF

git diff

git add .
git checkout -b \${TOOLKIT_PROJECT}-pr1
git commit -m "Update Application in \${TOOLKIT_PROJECT}-staging namespace"
git push -u origin \${TOOLKIT_PROJECT}-pr1

`}</code></pre>
        <ul parentName="li">
          <li parentName="ul">{`Open Git Ops from Console Link`}</li>
          <li parentName="ul">{`Select toolkit/gitops git repository`}</li>
          <li parentName="ul">{`Create a Pull Request`}</li>
          <li parentName="ul">{`Select Pull Request`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`New Pull Request`}</strong></li>
          <li parentName="ul">{`Select from `}<inlineCode parentName="li">{`compare`}</inlineCode>{` dropdown the branch `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-pr1`}</inlineCode></li>
          <li parentName="ul">{`Enter a title like `}<inlineCode parentName="li">{`Update replica count for app in namespace $TOOLKIT_PROJECT`}</inlineCode></li>
          <li parentName="ul">{`Enter a Comment like `}<inlineCode parentName="li">{`We need more instances business is growing Yay!`}</inlineCode></li>
          <li parentName="ul">{`click `}<strong parentName="li">{`Create Pull Request`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "996px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "98.2638888888889%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIBBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHu1JKYWaIwH//EABYQAQEBAAAAAAAAAAAAAAAAABEQIP/aAAgBAQABBQIrr//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABQQAQAAAAAAAAAAAAAAAAAAADD/2gAIAQEABj8CH//EABwQAAEDBQAAAAAAAAAAAAAAAAABEBEhMUFxgf/aAAgBAQABPyEcbRSs4gkS6v8A/9oADAMBAAIAAwAAABCkwL7/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEAAgMAAwEAAAAAAAAAAAABABEhMWFxobHR/9oACAEBAAE/EPAe0SitIAg16mWcV7s/ZbNPFM/Y12Mz4MtlT//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Pull Request 1",
                "title": "Pull Request 1",
                "src": "/dev-guide/static/94c7371275b3205d340ba675ffa15df5/e30fe/gitops-pr1.jpg",
                "srcSet": ["/dev-guide/static/94c7371275b3205d340ba675ffa15df5/69549/gitops-pr1.jpg 288w", "/dev-guide/static/94c7371275b3205d340ba675ffa15df5/473e3/gitops-pr1.jpg 576w", "/dev-guide/static/94c7371275b3205d340ba675ffa15df5/e30fe/gitops-pr1.jpg 996w"],
                "sizes": "(max-width: 996px) 100vw, 996px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the PR follow the change management process established by your team.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Click Merge Pull Request`}</li>
          <li parentName="ul">{`Click Delete Branch`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review that application scales out`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Review in ArgoCD UI, notice there are now two pods, it takes about 4 minutes to sync, you can click `}<strong parentName="li">{`Refresh`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "32.29166666666667%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAGABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdmhAP/EABYQAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAQABBQJGv//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAABD/2gAIAQEABj8Cf//EABgQAAMBAQAAAAAAAAAAAAAAAAABESGB/9oACAEBAAE/IeGK0Uf/2gAMAwEAAgADAAAAEAv/AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAAMBAQEAAAAAAAAAAAAAAAABESFRkf/aAAgBAQABPxBzMCRAho54f//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Argo Stagaing 2 pods",
                "title": "Argo Stagaing 2 pods",
                "src": "/dev-guide/static/fce721e37ce0febb89c65ff28213d543/2e753/argo-app-staging2.jpg",
                "srcSet": ["/dev-guide/static/fce721e37ce0febb89c65ff28213d543/69549/argo-app-staging2.jpg 288w", "/dev-guide/static/fce721e37ce0febb89c65ff28213d543/473e3/argo-app-staging2.jpg 576w", "/dev-guide/static/fce721e37ce0febb89c65ff28213d543/2e753/argo-app-staging2.jpg 1152w", "/dev-guide/static/fce721e37ce0febb89c65ff28213d543/995f9/argo-app-staging2.jpg 1378w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`Review in OpenShift Console, click the Deployment circle details shows 2 Pods.
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "40.27777777777778%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAIABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAIEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAbOkEwf/xAAWEAADAAAAAAAAAAAAAAAAAAAEEDP/2gAIAQEAAQUCBiv/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAWEAADAAAAAAAAAAAAAAAAAAABEHL/2gAIAQEABj8CNP8A/8QAGBAAAgMAAAAAAAAAAAAAAAAAABARIXH/2gAIAQEAAT8hvqUH/9oADAMBAAIAAwAAABBzz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABsQAAICAwEAAAAAAAAAAAAAAAERAGEhQXGB/9oACAEBAAE/EFKQ4UJtJXAKyAfJ/9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Openshift Stagaing 2 pods",
                "title": "Openshift Stagaing 2 pods",
                "src": "/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/2e753/deploy-staging2.jpg",
                "srcSet": ["/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/69549/deploy-staging2.jpg 288w", "/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/473e3/deploy-staging2.jpg 576w", "/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/2e753/deploy-staging2.jpg 1152w", "/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/74f4b/deploy-staging2.jpg 1728w", "/dev-guide/static/38867d82ed1d5e87176e5a1372459a17/749d3/deploy-staging2.jpg 1914w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Congratulations you finished this activity, continue with the lab `}<a parentName="p" {...{
            "href": "../inventory"
          }}>{`Deploy a 3 tier Microservice using React, Node.js, and Java`}</a></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      